import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import { initialize } from 'state/app';
import { useDispatch, useSelector } from 'react-redux';
import RenderWrapper from './private-render-wrapper';

/**
 * Routes that are displayed only if user is authenticated
 *
 * If user not authenticated and tried to access,
 * save original address to state amd redirect back here after login
 */
const PrivateRoute = ({
  component,
  path,
  product = 'nomad_insurance',
  renderProps = {}
}) => {
  const { isInitialized, isInitInProgress, initializedProduct, user } = useSelector(
    (state) => state.app
  );
  const dispatch = useDispatch();

  const createRenderWrapper = (renderPropsWrapper) => (
    <RenderWrapper
      user={user}
      initialize={(redirectOnUnauthorized, product) =>
        dispatch(initialize(redirectOnUnauthorized, product))
      }
      isInitialized={isInitialized}
      isInitInProgress={isInitInProgress}
      component={component}
      renderProps={{ ...renderPropsWrapper, ...renderProps }}
      product={product}
      initializedProduct={initializedProduct}
    />
  );

  return <Route path={path} render={createRenderWrapper} />;
};

PrivateRoute.propTypes = {
  component: PropTypes.any,
  path: PropTypes.string,
  product: PropTypes.oneOf([
    'ambassador',
    'nomad_health',
    'remote_health',
    'nomad_insurance',
    'global'
  ]),
  renderProps: PropTypes.object
};

export default PrivateRoute;
